import React from 'react';
import { Page } from 'src/shared/design-system/ShefDashboard';
import { POST_TEXT } from '../consts';
import { PostPreviewProps } from '../types';
import { Post } from './Post';
import { PreviewText } from './styles';

export const Preview: React.FC<PostPreviewProps> = (props) => {
  const { showMenuLink = false, showTitle, title = POST_TEXT.PREVIEW.TITLE } = props;
  const post = <Post {...POST_TEXT.PREVIEW_DATA} isOnMenuPage={!showMenuLink} />;
  return showTitle ? (
    <>
      <PreviewText>{title}</PreviewText>
      <Page.Panel noContentPadding>{post}</Page.Panel>
    </>
  ) : (
    post
  );
};
